import { render, staticRenderFns } from "./Grafica.vue?vue&type=template&id=15c36655&"
import script from "./Grafica.vue?vue&type=script&lang=js&"
export * from "./Grafica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports